import { render, staticRenderFns } from "./MoneyInputV3.vue?vue&type=template&id=ffa67418&scoped=true&"
import script from "./MoneyInputV3.vue?vue&type=script&lang=ts&"
export * from "./MoneyInputV3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa67418",
  null
  
)

export default component.exports